import * as LDClient from 'launchdarkly-js-client-sdk';
import noop from 'lodash/noop';
var initializeLD = function (clientSideId, user, updateCallback) {
    if (clientSideId === void 0) { clientSideId = ''; }
    if (user === void 0) { user = { anonymous: true }; }
    if (updateCallback === void 0) { updateCallback = noop; }
    if (clientSideId) {
        var client_1 = LDClient.initialize(clientSideId, user);
        client_1.on('ready', function () {
            var flags = client_1.allFlags();
            console.log('LD Ready', flags);
            updateCallback(flags);
        });
        client_1.on('change', function () {
            var flags = client_1.allFlags();
            console.log('LD Update', flags);
            updateCallback(flags);
        });
    }
};
export default initializeLD;
